import { createAction } from 'redux-actions';

import encodeSearchQuery from 'ha/utils/encodeSearchQuery';
import { getCurrentLanguageCode } from 'ha/modules/LanguageSwitcher/selectors';
import LANGUAGES from 'ha/constants/Languages';
import { getFeatureFlags } from 'ha/modules/FeatureFlags';
import ApiError from 'ha/services/apiV2/errors/ApiError';

import { Actions } from '../constants';
import {
  getSearchParams,
  getPreviousParams,
  getCachedUpdateSearch,
} from '../selectors';

const flow = {
  start: createAction(Actions.UPDATE_SEARCH_START),
  done: createAction(Actions.UPDATE_SEARCH_DONE),
  error: createAction(Actions.UPDATE_SEARCH_ERROR),
};
const languageCodes = Object.keys(LANGUAGES);
const formatResponse = (resData, currentLanguageCode) => {
  const langUrlList = languageCodes.reduce(
    (result, languageCode) => ({
      ...result,
      ...{ [languageCode]: resData[languageCode].searchUrl },
    }),
    {},
  );

  return {
    city: resData[currentLanguageCode].cityCanonical,
    cityLocalized: resData[currentLanguageCode].cityName,
    country: resData[currentLanguageCode].countryCanonical,
    countryCode: resData[currentLanguageCode].countryCode.toLowerCase(),
    countryLocalized: resData[currentLanguageCode].countryName,
    langURLList: langUrlList,
    latitude: resData[currentLanguageCode].latitude,
    longitude: resData[currentLanguageCode].longitude,
    minZoomLevel: resData[currentLanguageCode].mapMinZoom,
    radius: resData[currentLanguageCode].mapRadius,
    zoomLevel: resData[currentLanguageCode].mapZoom,
  };
};

const getCitySearch = (city, country) => {
  return encodeSearchQuery(`${city}, ${country}`);
};

export default () => (dispatch, getState, services) => {
  const state = getState();
  const { citySearch } = getSearchParams(state);
  const { citySearch: prevCitySearch } = getPreviousParams(state);

  if (citySearch === prevCitySearch) {
    return Promise.resolve(getCachedUpdateSearch(state));
  }

  const currentLanguageCode = getCurrentLanguageCode(getState());

  dispatch(flow.start());

  return services.apiV2
    .searchCity({
      query: citySearch,
      languages: languageCodes,
    })
    .then(response => {
      const formattedResponse = formatResponse(
        response.data,
        currentLanguageCode,
      );

      dispatch(flow.done(formattedResponse));

      const { set404ToSearchMissmatch } = getFeatureFlags(state);
      const { cityName, countryName } = response.data[currentLanguageCode];
      const citySeachFound = getCitySearch(cityName, countryName);

      if (set404ToSearchMissmatch === 'on' && citySearch !== citySeachFound) {
        return Promise.reject(
          new ApiError(404, 'Missmatched City Country', {}),
        );
      }

      return formattedResponse;
    })
    .catch(errors => {
      if (errors.status !== 404) {
        dispatch(flow.error(errors));
      }

      return Promise.reject(errors);
    });
};
